import { FormattedMessage, useIntl } from 'react-intl'
import { useTable } from 'react-table'
import clsx from 'clsx'

import { Card, CardBody, CardHeader, Heading } from 'Components/_theme'

import { TableCardProps } from './TableCard.types'

export const TableCard = <T extends {}>(props: TableCardProps<T>) => {
  const {
    heading,
    icon,
    iconColor,
    total,
    columns,
    data,
    className,
    tableClassName,
  } = props
  const { formatMessage } = useIntl()
  const translatedTotal = formatMessage(
    { id: 'TableCard_total' },
    { amount: total },
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    })

  return (
    <Card className={className}>
      <CardHeader color={iconColor} icon={icon} subtitle={translatedTotal}>
        <FormattedMessage id={heading} />
      </CardHeader>

      <CardBody className="pt-0 px-0">
        <table
          className={clsx('TableCard', tableClassName)}
          {...getTableProps()}
        >
          <thead className="TableCard-head">
            {headerGroups.map(headerGroup => (
              <tr
                className="TableCard-row TableCard-row--head"
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map(column => (
                  <th
                    className="TableCard-cell TableCard-cell--head"
                    {...column.getHeaderProps()}
                  >
                    <Heading as={6} size={2}>
                      {column.render('Header')}
                    </Heading>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="TableCard-body" {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)

              return (
                <tr className="TableCard-row" {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td className="TableCard-cell" {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </CardBody>
    </Card>
  )
}
